import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './styles.module.scss';

const FormTitle = ({title, className}) => {
  return (
    <h2 className={classnames(styles.formTitle, className)}>
      {title}
    </h2>
  );
};

FormTitle.propTypes = {
  title: PropTypes.node,
  className: PropTypes.string,
};

export default FormTitle;
